import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cache = {};

/**
 * Pulls a page's hero content from the unified `/api/hero-content/{slug}`
 * endpoint and returns it as a plain object. Pages render their own hero
 * layout but read text, buttons, pills, and slide images from this hook so
 * admins can edit everything from one dashboard.
 */
export function useHero(slug, fallback = null) {
  const [hero, setHero] = useState(cache[slug] || fallback || {});

  useEffect(() => {
    if (!slug) return undefined;
    let cancelled = false;
    axios
      .get(`${API}/hero-content/${slug}`)
      .then((res) => {
        if (cancelled) return;
        cache[slug] = res.data;
        setHero(res.data);
      })
      .catch(() => {
        /* leave fallback in place */
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return hero || {};
}

export default useHero;
